import { derived, writable } from 'svelte/store';
import { get } from 'svelte/store';

import { cmsConfig } from '$lib/services/config';

import { fetchAuthConfig } from './google-auth';

/** @type {import('svelte/store').Writable<boolean | undefined>} */
const gitbaseMode = writable(undefined);

export { gitbaseMode as isGitbaseModeStore };

/** @returns {boolean} */
export const isGitbaseAdminSite = () =>
  typeof window !== 'undefined' && window.location.pathname.includes('/admin');

/** @returns {boolean} */
export const getGitbaseMode = () => get(gitbaseMode) === true || isGitbaseAdminSite();

/**
 * Detect GitBase mode: GitHub backend on an /admin site with server auth routes.
 */
export const detectGitbaseMode = async () => {
  const isAdminPath = window.location.pathname.includes('/admin');

  if (!isAdminPath) {
    gitbaseMode.set(false);
    return false;
  }

  const config = get(cmsConfig);
  const backend = config?.backend;

  // Config may not be loaded yet when initGitbase() runs; don't cache a false result.
  if (!backend?.name) {
    return get(gitbaseMode) === true;
  }

  if (backend.name !== 'github') {
    gitbaseMode.set(false);
    return false;
  }

  if (get(gitbaseMode) === true) {
    return true;
  }

  try {
    await fetchAuthConfig();
    gitbaseMode.set(true);
    return true;
  } catch {
    gitbaseMode.set(false);
    return false;
  }
};

/**
 * Reactive GitBase mode flag for Svelte components.
 * @type {import('svelte/store').Readable<boolean>}
 */
export const isGitbaseMode = derived(gitbaseMode, ($mode) => $mode === true || isGitbaseAdminSite());
